<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="query.fState"
        placeholder="状态"
        style="width: 100px"
        size="small"
        clearable
      >
        <el-option value="未审核">未审核</el-option>
        <el-option value="已审核">已审核</el-option>
      </el-select>
      <el-input
        v-model="query.fBillNo"
        placeholder="入库单号"
        size="small"
        style="width: 200px"
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
    </div>
    <div class="query-bar">
      <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_new"
      >新增</el-button>
      <el-button
        v-if="candel"
        type="danger"
        size="small"
        :loading="auditing"
        @click="_del"
      >删除<span v-if="delling">中...</span></el-button>
      <el-button
        v-if="canAudit"
        type="success"
        size="small"
        :loading="auditing"
        @click="_audit"
      >审核<span v-if="auditing">中...</span></el-button>

      <el-button
        v-if="canUnAudit"
        type="warning"
        size="small"
        :loading="unauditing"
        @click="_unaudit"
      >反审<span v-if="unauditing">中...</span></el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        :row-style="{ cursor: 'default' }"
        @row-dblclick="_view"
        @select="rowSelect"
        @select-all="rowSelect"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="fBillNo" label="入库单号" />
        <el-table-column prop="fCreater" label="制单人" />
        <el-table-column prop="fState" label="单据状态" />
        <el-table-column prop="createTime" label="制单日期" />
        <el-table-column prop="fDate" label="入库日期" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_view(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'
import DealResults from './DealResults'

export default {
  components: {
    ConfirmButton
  },
  components: {
    DealResults
  },
  data() {
    return {
      query: {
        fState: '未审核',
        fBillNo: null,

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      auditing: false,
      unauditing: false,
      delling: false,
      currentEditItem: null,
      canAdd: true,
      canEdit: true,
      canAudit: true,
      canUnAudit: true,
      candel: true
    }
  },
  mounted() {
    this.refresh()

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '003002002') {
        this.canAdd = val.isGrant
      }
      if (val.key == '003002003') {
        this.canEdit = val.isGrant
      }
      if (val.key == '003002004') {
        this.canAudit = val.isGrant
      }
      if (val.key == '003002005') {
        this.canUnAudit = val.isGrant
      }
      if (val.key == '003002006') {
        this.candel = val.isGrant
      }
    })
  },
  methods: {
    rowSelect: function(selction) {
      this.currentEditItems = selction
    },

    refresh() {
      this.loading = true
      this.$httpPost('Warehouse/ProductStock/ProductStockEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }

          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    _new: function() {
      const url = this.$route.path + '/' + 0
      this.$router.push(url)
    },
    _view: function(row) {
      const url = this.$route.path + '/' + row.fid
      this.$router.push(url)
    },
    _audit: function() {
      this.auditing = true
      this.postData(2, '审核').finally(() => {
        this.auditing = false
      })
    },
    _del: function() {
      this.delling = true
      this.postData(1, '删除').finally(() => {
        this.delling = false
      })
    },
    _unaudit: function() {
      this.unauditing = true
      this.postData(3, '反审核').finally(() => {
        this.unauditing = false
      })
    },
    postData: async function(type, msg) {
      const items = this.currentEditItems

      if (!items || !items.length) {
        this.$message.warning('请选中要操作的行')
        return
      }

      const confirmOK = await this.confirm(`是否${msg}所选行`)
      if (!confirmOK) return

      return this.$httpPost(`Warehouse/ProductStock/ProductStockBatch`, {
        datalist: JSON.stringify({
          modifyType: type,
          idList: items.map((x) => x.fid)
        })
      }).then((res) => {
        if (res.isSuccess) {
          if (res.datalist.failTotal > 0) {
            const h = this.$createElement
            this.$formDlg({
              title: `处理结果`,
              width: '30%',
              readonly: true,
              formTpl: (
                <DealResults form={res.datalist.failMessages}></DealResults>
              )
            })
          } else {
            this.$message.success(res.message)
          }
          this.currentEditItems = []
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    }
  }
}
</script>
